'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './shop.routes';

export class ShopComponent {

  constructor(ngCart, SettingsService, $state, Config) {
    'ngInject';

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Shop");

    ngCart.setTaxRate(7.5);
    ngCart.setShipping(2.99);

    SettingsService.getPublicByName({name: 'shop-data'}, setting => {
      this.data = setting.data;
      this.checkOutSettings = setting.data.config.checkout;
    });

    this.showCartView = false;
  }

  showCart(val) {
    this.showCartView = val;
  }
}

export default angular.module('conduuApp.shop', [uiRouter])
  .config(routes)
  .component('shop', {
    template: require('./shop.html'),
    controller: ShopComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/shop/shop.component.js